// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"0bb86db5","418":"eb36e11e","463":"d4f2d764","490":"bac74224","500":"c5349531","546":"108f8180","765":"2cdeb48a","786":"6e540fe6","922":"574d86f4"}[chunkId] + ".chunk.css";
};